<script setup lang="ts">
    import { IChatMessage } from '@/js/services/api/chat/chat';
    import TopListWidget from '../widgets/TopListWidget.vue';
    import AddAsWidget from './AddAsWidget.vue';
    import ChatMessage from './ChatMessage.vue';
    import { computed, onMounted, ref } from 'vue';
    import { __ } from '@/js/stores/expressions';
    import ParsedMarkdown from '../ParsedMarkdown.vue';

    const props = defineProps<{ message: IChatMessage }>();

    const listData = ref<JSON | null>(null);

    onMounted(() => {
        try {
            listData.value = JSON.parse(props.message.content as string) ?? {};
        } catch (error) {
            console.error('Failed to parse list data:', error);
            listData.value = null;
        }
    });

    const markdown = computed(() => props.message.message as string);
</script>

<template>
    <ChatMessage :message="message">
        <ParsedMarkdown :markdown="markdown" />

        <template #after>
            <div
                class="bg-white mt-2 shadow-md rounded-lg border border-gray-light p-4 pr-10 relative"
            >
                <template v-if="listData">
                    <AddAsWidget widget-type="TopList" :data="listData" />
                    <TopListWidget :data="listData" />
                </template>
                <template v-else>
                    <div class="text-error">
                        {{ __('list-data-error') }}
                    </div>
                </template>
            </div>
        </template>
    </ChatMessage>
</template>
